import { render } from "./FaqWindow.vue?vue&type=template&id=f399be22&scoped=true"
import script from "./FaqWindow.vue?vue&type=script&lang=js"
export * from "./FaqWindow.vue?vue&type=script&lang=js"

import "./FaqWindow.vue?vue&type=style&index=0&id=f399be22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f399be22"]])

export default __exports__